import React from "react"
import { Container } from "@material-ui/core"
import clsx from "clsx"
import Button from "@material-ui/core/Button"
import * as styles from "./slider.module.scss"
import { variantConfig } from "./variants"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

type SliderProps = {
  orderNum: string
  variant?: "base"
  headTitle: string | JSX.Element
  headDescr: string | JSX.Element
}

type ButtonVariant = "text" | "outlined" | "contained" | undefined

export const Slider = ({ variant = "base", orderNum, headTitle, headDescr }: SliderProps) => {
  const data = variantConfig[variant]

  const handleClick = (buttonText: string) => {
    DLClickEventExtended({ name: buttonText, eventAction: "Больше выгоды", placement: "benefits" })
    scrollToPersonalForm()
  }

  return (
    <section id="benefits" data-exclude={orderNum}>
      <Container className={clsx(styles.container, variant && styles[variant])}>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}
        {headDescr && <p className={styles.headDescr}>{headDescr}</p>}

        <div className={styles.cardList}>
          {data.map(({ title, buttonText, buttonVariant, benefits }, index) => (
            <div key={index} className={`${styles.card} ${styles[`card${index + 1}`]}`}>
              {title && <div className={styles.title}>{title}</div>}
              <div className={styles.benefitsList}>
                {benefits.map(({ smallText, bigText, Icon, alt }) => (
                  <div className={styles.benefit}>
                    <Icon alt={alt} className={styles.img} />
                    <div className={styles.benefitText}>
                      <span>{smallText}</span>
                      <p>{bigText}</p>
                    </div>
                  </div>
                ))}
              </div>

              {buttonText && (
                <Button
                  variant={buttonVariant as ButtonVariant}
                  disableRipple
                  onClick={() => handleClick(buttonText)}
                  className={
                    buttonVariant === "outlined" ? styles.btnOutlined : styles.btnContained
                  }
                >
                  {buttonText}
                </Button>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
